import { ref, shallowRef, type Ref, type ShallowRef } from 'vue';

import { useFocusReturn } from '@/composables/useFocusReturn';

// A dialog whose content outlives `open`, so v-dialog can play its exit transition. Bind
// `:key="key"` so every opening mounts a fresh form. Closing returns focus to the opener.
export function useKeptDialog<T>(): { payload: ShallowRef<T | null>; open: Ref<boolean>; key: Ref<number>; show: (payload: T) => void; close: () => void } {
  const payload = shallowRef<T | null>(null);
  const open = ref(false);
  const key = ref(0);
  const focus = useFocusReturn();

  function show(next: T): void {
    focus.remember();
    payload.value = next;
    key.value += 1;
    open.value = true;
  }

  function close(): void {
    open.value = false;
    focus.restore();
  }

  return { payload, open, key, show, close };
}
